import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import Typography from '../Typography';
import { useCategoryPageContext } from "../../contexts/app/CategoryPageContext";
import AxiosService from "../../services/axios.service";
import { log } from 'console';

function valuetext(value: number) {
  return `${value}`;

}


export default function RangeSliderSearch() {

  const { addFilter, filters, categoryId, categoryProducts } = useCategoryPageContext()
  const [maxPrice, setMaxPrice] = useState<number>(50)
  const [minPrice, setMinPrice] = useState<number>(0)
  const [value, setValue] = useState<number[]>([minPrice, maxPrice])

  const handleChange = (event: Event, newValue: number | number[]) => {
    setValue(newValue as number[])
  };

  const handlePriceFilter = (event: Event, newValue: number | number[]) => {

    addFilter('price', value)

  };

  useEffect(() => {

    const temp = categoryProducts.map((pr: { price: any }) => {
      return Number(pr.price)
    })

    setMinPrice(Math.min(...temp))
    setMaxPrice(Math.max(...temp))
    setValue([0, maxPrice])

  }, [minPrice, maxPrice])

  

  return (
    <Box ml={1} sx={{ width: '95%' }}>
      <Slider
        getAriaLabel={() => 'Price range'}
        value={value}
        onChangeCommitted={handlePriceFilter}
        onChange={handleChange}
        valueLabelDisplay="auto"
        getAriaValueText={valuetext}
        sx={{ color: 'royalblue' }}
        min={0}
        step={0.01}
        max={maxPrice}
        
      />
      <Typography align="center" color='white'>
        {parseFloat(value[0]).toFixed(2)}€ - {parseFloat(value[1]).toFixed(2)}€
      </Typography>
    </Box>
  );
}
